var _title, _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPencil = function SvgPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "54. Pencil")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "54.-Pencil",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 2.000000)",
    stroke: "currentColor",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6455517,8.78427836 C68.727981,7.71300814 70.3516249,6.10610281 72.5164835,3.96356236 C76.8061718,-0.28190241 83.7093961,-0.333103771 87.9327727,3.84673285 L92.8291664,8.69264826 C97.0536595,12.8735899 97.0017515,19.7036085 92.7111199,23.9500067 C90.4469841,26.1908009 88.7488823,27.8713965 87.6168144,28.9917936",
    id: "Layer-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7755102,68.8339996 L26.5638297,84.4595528",
    id: "Layer-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Layer-3",
    points: "15.0475446 91.3095912 0.00769088282 95.7112859 4.47127677 80.8423571 15.0475446 91.3095912"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Layer-4",
    points: "8.55233711 67.2682845 67.5828129 8.84637033 77.6801466 18.8396078 87.930731 28.6969881 28.9002552 87.1189023 0 95.9798022"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pencil.5f0e7380.svg";
export { ForwardRef as ReactComponent };